import React from 'react';
import { HintPlacement, SimpleHint, Text, TextExtendedProps } from '@common-fe/common-fe';
import styled from 'styled-components';
interface Props extends TextExtendedProps {
  children: React.ReactNode;
  hint?: React.ReactNode;
  preferAlign?: HintPlacement;
}

const StyledText = styled(Text)`
  text-decoration-line: underline;
  text-decoration-style: dotted;
  text-decoration-skip-ink: auto;
  text-underline-offset: 0px;
  text-underline-position: from-font;
  text-decoration-color: ${({ theme }) => theme.colors.border};
`;
const HintTitle: React.FC<Props> = ({ children, hint, preferAlign = HintPlacement.BOTTOM, ...rest }) => {
  if (!hint) {
    return (
      <StyledText data-testid="hint-title" {...rest}>
        {children}
      </StyledText>
    );
  }
  return (
    <SimpleHint isFixed preferAlign={preferAlign} width="225px" content={hint}>
      <StyledText data-testid="hint-title" {...rest}>
        {children}
      </StyledText>
    </SimpleHint>
  );
};

export default HintTitle;
